import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableTree = _resolveComponent("TableTree")!
  const _component_StatisticsBaseSwitchTab = _resolveComponent("StatisticsBaseSwitchTab")!

  return (_openBlock(), _createBlock(_component_StatisticsBaseSwitchTab, {
    textTrue: _ctx.firstTitle,
    textFalse: _ctx.secondTitle,
    pdfFirstTitle: _ctx.firstTitle,
    pdfSecondTitle: _ctx.secondTitle
  }, {
    "first-tab": _withCtx(() => [
      _createVNode(_component_TableTree, {
        columns: _ctx.groupsTableConfig.columns,
        storePaths: _ctx.groupsTableConfig.storePaths,
        params: _ctx.filter,
        itemKey: "name"
      }, null, 8, ["columns", "storePaths", "params"])
    ]),
    "second-tab": _withCtx(() => [
      _createVNode(_component_TableTree, {
        columns: _ctx.usersTableConfig.columns,
        storePaths: _ctx.usersTableConfig.storePaths,
        params: _ctx.filter,
        itemKey: "fullName"
      }, null, 8, ["columns", "storePaths", "params"])
    ]),
    _: 1
  }, 8, ["textTrue", "textFalse", "pdfFirstTitle", "pdfSecondTitle"]))
}